import { useDeleteProgressionTemplateMutation } from "../../libs/progression/api";
import { ProgressionTemplate } from "../../libs/progression/types";
import { Modal } from "../Modal";
import { DeleteButton } from "../Button";

type Props = {
  openModal: string | undefined;
  setOpenModal: (modal: string | undefined) => void;
  templateToDelete: ProgressionTemplate | undefined;
};

export const DeleteProgressionModal: React.FC<Props> = ({
  openModal,
  setOpenModal,
  templateToDelete,
}) => {
  const [deleteTemplate, { isLoading, error }] = useDeleteProgressionTemplateMutation();

  const onDelete = () => {
    if (!templateToDelete) return;
    deleteTemplate(templateToDelete.id)
      .unwrap()
      .then(() => setOpenModal(undefined))
      .catch(() => {});
  };

  if (!templateToDelete) return null;

  return (
    <Modal
      title={`Elimina: ${templateToDelete.name}`}
      openModal={openModal === "delete" ? "delete" : undefined}
      setOpenModal={setOpenModal}
    >
      <p className="mb-4 text-gray-600">
        Sei sicuro di voler eliminare questa progressione? L&apos;operazione non può essere annullata.
      </p>
      <DeleteButton isPending={isLoading} onClick={onDelete} />
      {error && (
        <p className="mt-2 text-sm text-red-600">
          Errore durante l&apos;eliminazione della progressione.
        </p>
      )}
    </Modal>
  );
};
